import type { ChatCompletionMessage, ChatProviderMessage } from './types';

export function hasRole<RoleType extends ChatCompletionMessage['role']>(
  message: ChatProviderMessage,
  role: RoleType,
): message is ChatProviderMessage<RoleType> {
  return message.message.role === role;
}
